import EdFormProps from 'simple-base-unit/lib/package/EdForm/src/Props'

export const FormProps = EdFormProps

let form_props = Object.assign({}, FormProps)
delete form_props.formData
delete form_props.formDesc

export  default {
    ...form_props,

    // 表单类型  query | edit
    formType: {type: String, default: "edit"},
    // 是搜索表单、还是提交表单 默认提交表单
    isSearchForm: {type: Boolean, default: false},
    // 数据源配置属性
    controlConfig: {type: Object, default: () => {}},
    // 查询单条数据 url  param
    loadQuery: {type: Object},
    // form 表单高度控制
    height: {type: String, default: 'auto'},
}
